<template>
  <ul class="handouts-list">
    <li v-for="file in files" :key="file.href">
      <handout :file="file"></handout>
    </li>
  </ul>
</template>

<script>
import Handout from './handout';

const HandoutsList = {
  name: 'HandoutsList',

  components: {
    Handout
  },

  computed: {
    files() {
      return this.$store.state.g2wSession ? this.$store.state.g2wSession.handouts.files : [];
    }
  }
};

export default HandoutsList;
</script>

<style lang="sass">
  .handouts-list
    list-style: none
    padding-left: 0

    li
      min-height: 70px
      display: flex
      align-items: center
      padding: 10px 0px

      & + li
        border-top: solid 1px #cecdcd

      .handout
        width: 100%
</style>
